<template>
	<div>
        <div class="col-12" v-if="loading">
            <loader></loader>
        </div>

		<div v-else-if="submissions && submissions.length">
            <div class="flex-table">
                <list-item
                    v-for="submission in submissions"
                    :key="submission.id"
                    @click="showSubmission(submission)"
                >
                    <template slot="title">
                        <div>
                            <h6 class="text-dark mb-0">{{submission.instance.name}}</h6>
                            <h6 v-bind:class="submission.form_status.class">{{submission.form_status.title_line_2}}</h6>
                            <div class="badge badge--negative badge--sm">{{submission.archived_difference}}</div>
                        </div>
                    </template>

                    <template slot="center">
                        <div class="badge badge--sm badge--secondary">{{submission.user.full_name}}</div>
                    </template>
                </list-item>
            </div>
		</div>
		<div class="form-submission-card" v-else>
            <div class="mt-2 form-submission-card-content" >
                <h5>No archived submissions</h5>
            </div>
        </div>
	</div>
</template>

<script>
	import Loader from "../general_components/Loader";
	export default {
		name: "JobArchivedFormSubmissions",
		components: {Loader},
		props: {
			load_url: {
				type: String,
				required: true
			},
			show_submission_url: {
				type: String,
				required: true
			},
			back_url: {
				type: String,
				required: true
			}
		},

		data() {
			return {
				loading: false,
				submissions: []
			}
		},

		mounted(){
			this.load();
		},

		methods: {
			load(){
				if (this.loading)
					return;

				this.loading = true;

				axios.get(this.load_url)
					.then(response => {
						this.submissions = response.data.submissions;
						this.loading = false;
					});
			},

			showSubmission(submission){
				window.location.href = this.show_submission_url.replace('?', submission.id) + '?back_url=' + this.back_url;
			},
		}
	}
</script>
